module.exports = __webpack_public_path__ + "img/brand-19.c3dac19b.png";